import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { GIPPackagingConstants } from '@core/constants/gip-packaging.constants';
import { AuthenticationService } from '@core/services';
import { StringUtils } from '@core/utils/string-utils.component';

import { catchError, throwError } from 'rxjs';

export const ErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const authenticationService = inject(AuthenticationService);

  return next(request).pipe(
    catchError((error) => {
      const isUnauthorized = error.status === HttpStatusCode.Unauthorized;
      const isServerError = error.status === HttpStatusCode.InternalServerError;

      const errorMessage = typeof error.error === 'string' ? error.error :
        error.error?.message || JSON.stringify(error.error);

      const hasInvalidCredentials =
        !StringUtils.isNullOrWhiteSpace(errorMessage) &&
        errorMessage.toLowerCase().includes(GIPPackagingConstants.ERROR.INVALID_CREDENTIALS.toLowerCase());

      if (isUnauthorized && !request.url.includes('authenticate')) {
        authenticationService.logout();
      } else if (isServerError && hasInvalidCredentials) {
        authenticationService.logout();
      }

      return throwError(() => error);
    })
  );
};
